module.exports = __webpack_public_path__ + "static/img/product13-1.3391a7a2.png";